import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/orangejuice.webp';
import screenshot_target from '../../../images/letterfunnel/remcovannieuwenhoven.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Remco van Nieuwenhoven"
      firstname="Remco"
      companyname="Orange Juice"
      competition="Perplex Digital en Digital Layers"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/remcovannieuwenhoven.js